import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import Header from '../component/Header';
import Footer from '../component/Footer';
import { useSelector } from 'react-redux';
import AdminLayout from '../component/AdminLayout';
const PrivateRoute = () => {
    const token = localStorage.getItem('access_token');
    const isAuthenticated = !!token;
    const showUserType = useSelector(state => state.userTypeSlice.userTypeAction)
    return (
        <>

            {/* {isAuthenticated  &&  showUserType == 'Public User' && <Header />}
        {isAuthenticated ? <Outlet /> : <Navigate to="/" />}
        {isAuthenticated &&  showUserType == 'Public User' && <Footer />} */}

            {isAuthenticated && showUserType === 'Public User' ? <Header /> : null}
            {isAuthenticated ? <Outlet /> : <Navigate to="/" />}
            {isAuthenticated &&  showUserType == 'Public User' ? <Footer /> : null}

        </>
    )
}

export default PrivateRoute